module.exports = __webpack_public_path__ + "static/media/chrome-texture-video.ec4fffbd.mp4";